import React, {useEffect, useState} from "react";

import "./IndicatorCapture.css";
import {StandardButton} from "../../../common/button/standard-button/StandardButton";
import {LeftLabelTextInput} from "../../../common/input/left-label-text-input/LeftLabelTextInput";
import {LeftLabelSelect} from "../../../common/input/left-label-select/LeftLabelSelect";
import {LeftLabelToggle} from "../../../common/input/left-label-toggle/LeftLabelToggle";
import {createIndicator, updateIndicator} from "../../../../services/IndicatorService";
import {retrieveAllTopicAreas} from "../../../../services/TopicAreaService";

export const IndicatorCapture = ({context, navigateTo, navigateBack, showToaster, setSpinnerText}) => {

    const [externalReference] = useState(context.selectedIndicator ? context.selectedIndicator.externalReference : null);
    const [indicator, setIndicator] = useState(context.selectedIndicator ? context.selectedIndicator.indicator : null);
    const [topicArea, setTopicArea] = useState(context.selectedIndicator ? context.selectedIndicator.topicArea : null);
    const [outcomeMeasure, setOutcomeMeasure] = useState(context.selectedIndicator ? context.selectedIndicator.outcomeMeasure : null);
    const [numerator, setNumerator] = useState(context.selectedIndicator ? context.selectedIndicator.numerator : null);
    const [denominator, setDenominator] = useState(context.selectedIndicator ? context.selectedIndicator.denominator : null);
    const [active, setActive] = useState(context.selectedIndicator ? context.selectedIndicator.active : null);
    const [topicAreas, setTopicAreas] = useState([]);

    useEffect(() => {
        setSpinnerText("Fetching Topic Areas");
        const fetchData = async () => {
            const [data, error] = await retrieveAllTopicAreas(context.username);
            if (data) {
                if (data.responseStatus === "Success") {
                    setTopicAreas(data.topicAreaVOList);
                } else {
                    showToaster(data);
                }
                setSpinnerText(null);
            } else {
                showToaster({
                    responseStatus: "Error",
                    responseMessage: error.message,
                });
                setSpinnerText(null);
            }
        }
        fetchData();
    }, []);

    const handleClick = async () => {
        const indicatorToBeSaved = {
            externalReference,
            indicator,
            topicAreaName: topicArea.topicArea,
            topicAreaExternalReference: topicArea.externalReference,
            outcomeMeasure,
            numerator,
            denominator,
            active,
        };

        if (null === externalReference) {
            setSpinnerText("Creating Indicator");
            const response = await createIndicator(context.username, indicatorToBeSaved);
            handleResponse(response);
        } else {
            setSpinnerText("Updating Indicator");
            const response = await updateIndicator(context.username, indicatorToBeSaved);
            handleResponse(response);
        }
    }

    const handleResponse = ([data, error]) => {
        if (data) {
            showToaster(data);
            if (data.responseStatus === "Success") {
                navigateTo("indicatorTable");
            }
            setSpinnerText(null);
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
        }
    }

    return (
        <div className="indicator-capture-container">
            <div className="indicator-capture-form-container">
                <LeftLabelTextInput labelText="Indicator:" defaultValue={indicator} handleChange={({target}) => {
                    setIndicator(target.value)
                }}/>
                <LeftLabelSelect labelText="Topic Area:"
                                 options={topicAreas}
                                 optionLabel={(option) => option.topicArea}
                                 optionValue={(option) => option.externalReference}
                                 value={topicArea}
                                 onChange={(topicArea) => {
                                     setTopicArea(topicArea)
                                 }}/>
                <LeftLabelTextInput labelText="Outcome Measure:" defaultValue={outcomeMeasure}
                                    handleChange={({target}) => {
                                        setOutcomeMeasure(target.value)
                                    }}/>
                <LeftLabelTextInput labelText="Numerator:" defaultValue={numerator} handleChange={({target}) => {
                    setNumerator(target.value)
                }}/>
                <LeftLabelTextInput labelText="Denominator:" defaultValue={denominator} handleChange={({target}) => {
                    setDenominator(target.value)
                }}/>
                <LeftLabelToggle labelText="Active: " active={active} setActive={setActive}/>
            </div>
            <div className="indicator-capture-button-container">
                <StandardButton text={context.selectedIndicator ? "Update Indicator" : "Add Indicator"}
                                onClick={handleClick}/>
                <StandardButton text="Back" onClick={navigateBack}/>
            </div>
        </div>
    );
}
